export enum Music {
	MAIN = "main_music",
	BOSS = "boss_music",
}
